export function assertUnreachable(branch: never): never {
  console.error(
    new Error(`This should not be reachable, likely there is a missing condition or switch case for branch ${branch as string}`)
  )
  throw new Error(`Unhandled case ${branch}`)
}
